import { DeleteOutlined, EditOutlined, PlusOutlined, SaveOutlined, SearchOutlined } from '@ant-design/icons';
import ModalTextForm from "@app/components/modal/ModalTextForm";
import { layDanhMucNhomLyDoNghiViec, luuNhomLyDoNghiViec, xoaNhomLyDoNghiViec } from "@app/services/danhmuc";
import { Button, Col, Form, Input, InputNumber, Row, Space, Table } from 'antd';
import Column from 'antd/es/table/Column';
import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { toast } from "react-toastify";
import { ContentHeader } from "../../components";
import { searchLength } from "../../constants";
import { validateMessages } from '../../helpers/common';
import { NhomLyDoNghiViec } from "../../models/danhmuc/DanhMuc";
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';

const QLNhomLyDoNghiViec = () => {
    const [data, setData] = useState<Array<NhomLyDoNghiViec>>([]);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const [page, setPage] = useState(1);
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [isLoadingBtn, setIsLoadingBtn] = useState<boolean>(false);
    const [showModalChiTiet, setShowModalChiTiet] = useState<boolean>(false);
    const [idXoa, setIdXoa] = useState<number>(0);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const setFormDetailModal = (value: NhomLyDoNghiViec | null) => {
        form.setFieldsValue({
            "id": value?.id,
            "ten": value?.ten || "",
            "thuTu": value?.thuTu || 0
        });
        setShowModalChiTiet(true);
    }

    const layDuLieu = async () => {
        try {
            setIsLoadingTable(true);
            let rs = await layDanhMucNhomLyDoNghiViec();
            setData(rs);
            setIsLoadingTable(false);
        } catch (error: any) {
            setIsLoadingTable(false);
        };
    }

    const onDelete = async () => {
        try {
            setIsLoadingBtn(true);
            await xoaNhomLyDoNghiViec(idXoa);
            toast.success('Xoá nhóm lý do nghỉ việc thành công!');
            // Tính toán số trang mới sau khi xóa
            const totalRecords = data.length - 1; // Số lượng bản ghi sau khi xóa
            let newPage = page;

            if (newPage > Math.ceil(totalRecords / searchLength)) {
                // Nếu trang hiện tại lớn hơn số trang mới tối đa
                newPage = Math.ceil(totalRecords / searchLength);
            }

            setPage(newPage);
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, xoá không thành công!');
        }
        setIdXoa(0);
        setReloadPage(true);
        setIsLoadingBtn(false);
    }

    const onFinish = async (values: any) => {
        try {
            dispatch(showLoadingScreen());
            setIsLoadingBtn(true);
            await luuNhomLyDoNghiViec(values);
            setShowModalChiTiet(false);
            toast.success('Lưu thông tin nhóm lý do nghỉ việcthành công!')
        }
        catch (err: any) {
            setShowModalChiTiet(false);
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
        }
        dispatch(hideLoadingScreen());
        setIsLoadingBtn(false);
        setReloadPage(true);
    };

    useEffect(() => {
        if (reloadPage) {
            layDuLieu();
            setReloadPage(false);
        }
    }, [reloadPage]);

    return (<section>
        <ContentHeader title="Quản lý danh mục nhóm lý do nghỉ việc" />
        {idXoa > 0 && <ModalTextForm show={idXoa > 0}
            title="Xoá nhóm lý do nghỉ việc"
            handleClose={() => setIdXoa(0)}
            handleSave={onDelete}>
            Xác nhận xóa nhóm lý do nghỉ việc đang chọn
        </ModalTextForm>}
        {showModalChiTiet && <ModalTextForm title="Quản lý nhóm lý do nghỉ việc"
            hideFooter
            show={showModalChiTiet}
            handleClose={() => setShowModalChiTiet(false)}
        >
            <Form
                layout="vertical"
                validateMessages={validateMessages}
                onFinish={onFinish}
                form={form}
            >
                <Form.Item hidden name="id"><Input /></Form.Item>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            label="Tên nhóm lý do nghỉ việc"
                            name="ten"
                            rules={[{ required: true, message: 'Vui lòng nhập tên nhóm lý do nghỉ việc' }]}
                        >
                            <Input placeholder="Tên nhóm lý do nghỉ việc" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Thứ tự"
                            name="thuTu"
                            rules={[{ required: true, message: 'Vui lòng nhập thứ tự nhóm lý do nghỉ việc' }]}
                        >
                            <InputNumber style={{ width: "100%" }} placeholder="Thứ tự" />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Button type="primary" loading={isLoadingBtn} className="float-right" htmlType="submit" icon=<SaveOutlined rev="" />>
                        Lưu
                    </Button>
                </Form.Item>
            </Form>
        </ModalTextForm>}
        <Row className="form-group" gutter={8}>
            <Col span={8}>
                <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập tên nhóm lý do nghỉ việc để tìm kiếm" onChange={(e) => { setPage(1); setTuKhoa(e.target.value) }} />
            </Col>
            <Col span={16}>
                <Button
                    className="hrm-btn hrm-btn-warning float-right"
                    onClick={() => {
                        setFormDetailModal(null);
                    }}
                    icon={<PlusOutlined rev="" />}
                >
                    Thêm mới
                </Button>
            </Col>
        </Row>
        <Row gutter={8}>
            <Col span={24}>
                <div className="card card-primary">
                    <Row>
                        <Col span={24}>
                            <Table
                                loading={isLoadingTable}
                                locale={{ emptyText: "Không có dữ liệu" }}
                                dataSource={data.map((item: any, index) => { item.key = index; return item; }).filter((record: NhomLyDoNghiViec) =>
                                    (record.ten.toLowerCase().includes(tuKhoa.toLowerCase()))
                                )}
                                rowClassName={(record, index) => {
                                    return (record?.id === idXoa) ? "selected-row row-key-" : "";
                                }}
                                pagination={{
                                    current: page,
                                    onChange: (page, pageSize) => {
                                        setPage(page);
                                    },
                                }}
                            >
                                <Column
                                    width="5%"
                                    title="STT"
                                    key="STT"
                                    render={(value, record, index) =>
                                    (
                                        <span key={"stt" + index}>
                                            {(page - 1) * searchLength + index + 1}
                                        </span>
                                    )
                                    }
                                />
                                <Column width="70%" title="Tên nhóm lý do nghỉ việc" dataIndex="ten" key="ten" />
                                <Column title="Thứ tự" dataIndex="thuTu" key="thuTu" />
                                <Column
                                    title=""
                                    key="action"
                                    render={(value, record, index) =>
                                    (
                                        <Space>
                                            <Button type="primary" size={"small"} title="Sửa"
                                                icon=<EditOutlined rev="" />
                                                onClick={() => { setFormDetailModal(value); }}
                                            >
                                                Sửa
                                            </Button>
                                            <Button type="primary" danger size={"small"} title="Xóa"
                                                onClick={() => { setIdXoa(value.id) }}
                                                icon=<DeleteOutlined rev="" />
                                            >
                                                Xóa
                                            </Button>
                                        </Space>
                                    )
                                    }
                                />
                            </Table>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    </section>
    );
}
export default QLNhomLyDoNghiViec;